import * as React from 'react';
import { BarChart } from "./BarChart";
import { ChartData, ChartDataContext } from "../context/Chart";
import { generateRandomRgb } from "../util/color";

const convertResultsetToChartData = (data: ChartData) => {

    const filteredData = data.result_set.filter((result_set) => result_set.passed_threshold);
    const colors = filteredData.map(() => {
        return generateRandomRgb();
    });

    return data.result_set[0].chapter.map((chapter,index) => {
        return {
            chapter: chapter.title,
            dataset: {
                labels: chapter.question.map(function (question) {
                    return question.title;
                }),
                datasets: filteredData.map(function (result_set) {
                    return result_set.chapter[index].question.map(function (question) {
                        return Math.round(question.average_score.average) / 10;
                    });
                }).map(function (data_set, index) {
                    return {
                        label: filteredData[index].title,
                        data: data_set,
                        backgroundColor: colors[index],
                        borderWidth: 0,
                        barPercentage: 1,
                        maxBarThickness: 10
                    };
                })
            }
        };
    });
}

export const QuestionCharts = () : JSX.Element => {
    const [data,] = React.useContext(ChartDataContext);
    const [questionsData,setQuestionsData] = React.useState(convertResultsetToChartData(data));

    React.useEffect(() => {
        if(!data.fetching&&!data.fetch){
            setQuestionsData(convertResultsetToChartData(data))
        }
    },[data]);

    const options = {
        scales: {
            x: {
                minBarLength: 2,
                gridLines: {
                    offsetGridLines: true
                },
                ticks: {
                    font: {
                        size: 10
                    },
                    callback: (value, index) => {
                        return index+1;
                    }
                }
            },
            y: {
                ticks: {
                    max: 10,
                    min: 0,
                    stepSize: 1
                }
            }
        },
        plugins : {
            legend: {
                display: true,
                position: 'right' as any
            }
        },
        tooltips: {
            callbacks: {
                title: function(tooltipItem, data) {
                    const sentence = data.labels[tooltipItem[0].index];

                    let maxLen: number = 50;
                    let rows: Array<string> = [];
                    let line: Array<string> = [];

                    sentence.split(' ').map((word) => {
                        if((line.join(' ') + word).length <= maxLen) {
                            line.push(word);
                        } else {
                            rows.push(line.join(' '));
                            line = [];
                        }
                    });
                    rows.push(line.join(' '));

                    return rows;
                }
            }
        }
    };

    return <div className={'c-rstats__charts'}>
        <h2>Resultaten vragen</h2>
        { questionsData.map((data,index) => {
            return <div key={`questiondata_${index}`}>
                <h3>Vragen bij {data.chapter}</h3>
                <BarChart data={data.dataset} options={options} label={`Vragen bij ${data.chapter}`} />
            </div>
        })}
    </div>;
}
